<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>
           Inter Code Stock Transsfer
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" md="12">
              <v-btn @click.native="transferDialog = true" small color="primary" class="mt-1">
                <v-icon left>mdi-plus</v-icon>New Inter Code Transfer
              </v-btn>
            </v-col>
  
            <v-col cols="12">
              <v-data-table
                :items-per-page="200"
                :headers="transferHeaders"
                :items="stockTransfers"
                :search="search"
              ></v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
  
      <!-- transfer modal -->
      <v-dialog v-model="transferDialog" max-width="650px">
        <v-card>
          <v-toolbar dense color="secondary" flat>
            <v-toolbar-title>Inter Code Transfer</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="transferDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row dense>
                <v-col cols="12" xs="12" md="12">
                  <v-autocomplete
                    autocomplete="off"
                    v-model="select"
                    :isloading="isLoading"
                    :items="products"
                    :search-input.sync="searchProducts"
                    @change="setTransferItem(select)"
                    :item-text="smsRef == 'pharmacy' ? 'full_name' : 'Name'"
                    item-value="id"
                    cache-items
                    class="mt-2"
                    flat
                    hide-no-data
                    hide-details
                    label="Search Product"
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
  
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    autocomplete="off"
                    type="number"
                    v-model="transferItem.AvailableQty"
                    label="Available Qty"
                    outlined
                    dense
                    filled
                    readonly
                  ></v-text-field>
                </v-col>
  
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    autocomplete="off"
                    type="number"
                    v-model="transferItem.TransferQty"
                    label="Transfer Qty"
                    outlined
                    dense
                    @input="qtyChanged(transferItem)"
                  ></v-text-field>
                </v-col>
  
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    filled
                    readonly
                    v-model="transferItem.StockBal"
                    label="Remaining Qty"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
  
                <v-col cols="12" xs="12" md="12">
                  <v-autocomplete
                    autocomplete="off"
                    v-model="targetProduct"
                    :isloading="isLoading"
                    :items="products"
                    :search-input.sync="searchToProduct"
                    :item-text="smsRef == 'pharmacy' ? 'full_name' : 'Name'"
                    item-value="id"
                    cache-items
                    class="mt-2"
                    flat
                    hide-no-data
                    hide-details
                    label="Transfer To"
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
  
                <v-col cols="6">
                  <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
                </v-col>
  
                <v-col cols="12">
                  <v-btn color="primary" @click="save" :loading="loader">
                    <v-icon left>mdi-plus</v-icon> Transfer Stock
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of modal -->
  
      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </template>
    
    <script>
  export default {
    components: {},
    computed: {
      activeStore() {
        return localStorage.getItem("store_id");
      }
    },
    data: () => ({
      dataItem: {},
      DefaultCustomer: null,
      AccountsVersion: null,
      outsourcedData: [],
      salePayments: [],
      docCreate: false,
      copyStatus: false,
      role: 3,
      search: null,
      loader: false,
      stockTransfers: [],
      products: [],
      isLoading: false,
      smsRef: null,
      select: "",
      targetProduct: "",
      searchingProduct: false,
      searchProducts: null,
      searchToProduct: null,
      transferDialog: false,
      transferItem: {},
      date: new Date().toISOString().substr(0, 10),
      transferHeaders: [
        { text: "Item Code", value: "DocNum" },
        { text: "Product Name", value: "fromstore.Name" },
        { text: "Quantity", value: "tostore.Name" },
        { text: "Transferred To", value: "DocDate" },
        { text: "Date", value: "DocDate" }
      ]
    }),
    watch: {
      searchProducts(val) {
        if (val && val !== this.select && this.querySelections(val)) {
          this.querySelections(val);
        }
      },
      searchToProduct(val) {
        if (val && val !== this.select && this.querySelections(val)) {
          this.querySelections(val);
        }
      }
    },
    methods: {
      querySelections(searchText) {
        const self = this;
  
        const url = "/search-products";
        const data = {
          searchText: searchText
        };
        this.$store
          .dispatch("post", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.products = res.ResponseData;
            } else {
              self.$store.commit("btnLoader", false);
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(err, "red");
          });
      },
      addRow() {},
      setDate(date) {
        this.date = date;
      },
      qtyChanged(data) {
        const self = this;
        const available = data.AvailableQty;
        if (data.TransferQty) {
          const StockBalance = available - data.TransferQty;
          self.transferItem = {
            ...self.transferItem,
            StockBal: StockBalance
          };
        } else {
          self.transferItem = {
            ...self.transferItem,
            StockBal: available
          };
        }
      },
      setTransferItem(id) {
        const self = this;
        this.$store.dispatch("get", `/products/${id}`).then(res => {
          const product = res.ResponseData;
  
          this.transferItem.LineNum = new Date().getTime();
          this.transferItem.ProductName = product.Name;
          this.transferItem.productId = product.id;
          this.transferItem.AvailableQty = product.AvailableQty;
          this.transferItem.ugp1 = product.ugpentry.ugp1;
          this.transferItem.ManualStatus = product.ugpentry.IsManual;
          self.transferItem.UomEntry = product.PUoMEntry;
          self.transferItem.id = product.itm2Id;
          // uom name
          let ugp1 = product.ugpentry.ugp1;
          if (product.ugpentry.IsManual == "N") {
            let ugp1Record = ugp1.find(record => {
              return record.uomentry.id === product.PUoMEntry;
            });
            this.transferItem.uomEntryName = ugp1Record.uomentry.UomName;
          } else {
            this.transferItem.uomEntryName = "Pcs";
          }
          // end
  
          if (this.role == 3) {
            const data = {
              productId: product.id
            };
            const url = `/get-buying-price`;
            // const self = this;
            self.$store.commit("btnLoader", true);
            this.$store
              .dispatch("post", { url, data })
              .then(res => {
                if (res.ResultCode == 1200) {
                  self.transferItem = {
                    ...self.transferItem,
                    StockBal: product.AvailableQty,
                    TransferQty: null,
                    SellingPrice: res.ResponseData.BuyingPrice
                  };
                  self.$store.commit("btnLoader", false);
                } else {
                  self.$store.commit("btnLoader", false);
                  this.$refs.snackbar.show(res.ResultDesc, "red");
                }
              })
              .catch(err => {
                self.$store.commit("btnLoader", false);
                this.$refs.snackbar.show(err, "red");
              });
          } else {
            self.transferItem.UomEntry = product.PUoMEntry;
            self.transferItem = {
              ...self.transferItem,
              StockBal: product.AvailableQty,
              TransferQty: null
            };
          }
        });
      },
      save() {
        if (this.date == null || this.date == undefined) {
          this.$refs.snackbar.show("Please select date!", "red");
          return;
        }
  
        if (this.select == "") {
          this.$refs.snackbar.show("Please select both products !", "red");
          return;
        }
  
        if (this.transferItem.TransferQty == null || this.transferItem.TransferQty  == undefined) {
          this.$refs.snackbar.show("Please fill the quantity !", "red");
          return;
        }
  
        if (this.targetProduct == "") {
          this.$refs.snackbar.show("Please select both products !", "red");
          return;
        }
  
        if (this.targetProduct == this.select) {
          this.$refs.snackbar.show("You cannot transfer to the same code !", "red");
          return;
        }
  
        const data = {};
        data.DocDate = this.date;
        data.baseProductId = this.select;
        data.targetProductId = this.targetProduct;
        data.Quantity =  this.transferItem.TransferQty;
        data.store_id = this.activeStore;
  
        const url = `/inter-code-transfer`;
        const self = this;
        self.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.$router.push("/transfer-drafts");
            } else {
              self.loader = false;
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            self.loader = false;
            this.$refs.snackbar.show(err, "red");
          });
      },
      getGenSettings() {
        const self = this;
        this.$store
          .dispatch("get", `/general-settings`)
          .then(res => {
            if (res.ResultCode == 1200) {
              self.DefaultCustomer = res.ResponseData.DefaultCustomer;
              self.AccountsVersion = res.ResponseData.AccountsVersion;
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    created() {
      this.getGenSettings();
    }
  };
  </script>